var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 7.5a.937.937 0 111.874 0 .937.937 0 01-1.874 0zm-.937-1.875a.937.937 0 100-1.875.937.937 0 000 1.875zM17.552 10a.625.625 0 00-.675.571 6.886 6.886 0 01-13.58.902 6.884 6.884 0 016.13-8.348.627.627 0 00-.104-1.25 8.134 8.134 0 108.802 8.802.625.625 0 00-.573-.677zM10 4.375a5.625 5.625 0 110 11.25 5.625 5.625 0 010-11.25zM9.375 10a.625.625 0 00.625.625h3.75a.625.625 0 100-1.25h-3.125V6.25a.625.625 0 00-1.25 0V10zM12.5 3.75a.937.937 0 100-1.875.937.937 0 000 1.875z",
    fill: "#A4A4A4"
  })));
}

export default SvgTimer;